import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AuthService} from '../../../Services/BuissnessLogic/auth.service';
import { loadScript } from '@paypal/paypal-js';
import {CheckoutService} from '../../../Services/BuissnessLogic/Checkout/checkout.service';
import {ColorScssService} from '../../../shared/service/color-scss.service';
import {PaypalService} from '../../../Services/BuissnessLogic/Paypal/paypal.service';
import {ConfiguratorStateService} from '../../../Services/ListConfiguration/configurator-state.service';
import { CheckoutOrder } from '../../../Services/BuissnessLogic/Checkout/checkout.service';
import {PayPalButtonComponent} from '../paypal/paypal-button/paypal-button.component';
import {MatCheckbox} from '@angular/material/checkbox';
import {CurrencyPipe, DecimalPipe, NgForOf, NgIf} from '@angular/common';
import {CheckoutHelperService} from '../../../Services/BuissnessLogic/Checkout/checkout-helper.service';


@Component({
    selector: 'app-checkout',
    standalone: true,
    imports: [PayPalButtonComponent, MatCheckbox, ReactiveFormsModule, NgIf, CurrencyPipe, DecimalPipe, RouterLink, NgForOf],
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent {
    public checkoutForm: FormGroup;
    public submitted:boolean = false;
    public orderId: string = "";
    // Form Validator
    constructor(private fb: FormBuilder,
                private router: Router,
                private auth: AuthService,
                private color: ColorScssService,
                public configState: ConfiguratorStateService,
                private checkoutHelper: CheckoutHelperService,
    ) {
        color.resetColorScheme()
        this.checkoutForm = this.fb.group({
            companyName: [''],
            firstname: ['', [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
            lastname: ['', [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
            phone: ['', [Validators.pattern('[0-9]+')]],
            email: ['', [Validators.required, Validators.email]],
            address: ['', [Validators.required, Validators.maxLength(50)]],
            town: ['', Validators.required],
            agb: [false, Validators.requiredTrue],
            widerruf: [false, Validators.requiredTrue],
        });
    }

    onSubmitBank() {
        this.submitted = true;
        if (this.checkoutForm.invalid) {
            this.checkoutForm.markAllAsTouched();
            return;
        }

        this.checkoutHelper.sendPurchaseInfoToBackend(this.checkoutForm.value, "Bank").subscribe({
            next: (response) => {
                if (response && response.success) {
                    this.orderId = response.orderId;
                } else {
                    this.orderId = "";
                    return;
                }
                if (!this.auth.isLoggedIn()) {
                    this.router.navigate(["/thank-you-bank"]);
                } else {
                    this.router.navigate(["/profil"]);
                }
            },
            error: (err) => {
                console.error('Order failed', err);
            }
        });
    }
    markAllFieldsTouched = () => {
        this.checkoutForm.markAllAsTouched();
    }
}
